export default __webpack_public_path__ + "static/media/v.9d824a69.jpg";